import { Injectable } from '@angular/core';
import { CrudApiProvider } from '../crud-api/crud-api';
import { UserProvider } from '../user/user';
import * as debug from 'debug';
import * as moment from 'moment';
import * as _ from 'lodash';

@Injectable()
export class LeaderboardProvider {
  log = debug('app:LeaderboadProvider');
  static leaderboardData: any;
  lastUpdated: any;
  lastUserId: any;
  info: any = {};

  constructor(public crudApi: CrudApiProvider, public user: UserProvider) {
    this.info = LeaderboardProvider.leaderboardData;
  }

  getLeaderBoard(userId: string) {
    return new Promise(async (resolve, reject) => {
      const query = {};

      if (userId) {
        query['userId'] = userId;
      }

      if (
        this.info &&
        this.lastUpdated &&
        moment(new Date()).diff(moment(this.lastUpdated), 'minutes') < 5 &&
        userId &&
        userId === this.lastUserId
      ) {
        return resolve(this.info);
      }

      this.lastUpdated = new Date();

      if (userId) {
        this.lastUserId = userId;
      }

      await this.crudApi
        .get('/api/leaderboard', query)
        .then(res => {
          const data = _.get(res, 'data');

          LeaderboardProvider.leaderboardData = this.info = data;

          return resolve(data);
        })
        .catch(e => {
          reject(null);
        });
    });
  }

  get(k?: any) {
    if (k === undefined) {
      return this.info;
    }
    return _.get(this.info, k);
  }
}



// WEBPACK FOOTER //
// ./src/providers/leaderboard/leaderboard-provider.ts